const API_BASE = 'https://futurista-api-v3-520601931215.us-central1.run.app';
const API_KEY = process.env.REACT_APP_API_KEY;

const HEADERS = {
  'Content-Type': 'application/json',
  'X-API-Key': API_KEY
};

// ── Plumber endpoints ─────────────────────────────────────────────────────

// Aplanar valores que vienen como arrays de un elemento desde Plumber
function flattenSignal(s) {
  const result = {};
  Object.keys(s).forEach(k => {
    result[k] = Array.isArray(s[k]) ? s[k][0] : s[k];
  });
  return result;
}

export async function fetchSignalsFromPlumber(problema, dias = 180, limite = 50, sector = "") {
  try {
    const res = await fetch(`${API_BASE}/analyze`, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ problema, dias, limite, sector })
    });
    const data = await res.json();
    if (data.data && data.data[0]) {
      console.log("Sample signal umap_x:", data.data[0].umap_x, typeof data.data[0].umap_x);
      console.log("After flatten:", flattenSignal(data.data[0]).umap_x);
    }
    return (data.data || []).map(flattenSignal);
  } catch (e) {
    console.error('Plumber /analyze error:', e);
    return [];
  }
}


export async function extractKeywords(problema) {
  try {
    const res = await fetch(`${API_BASE}/llm`, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ problema, resumen: '', tipo: 'keywords' })
    });
    const data = await res.json();
    return data.texto || problema;
  } catch (e) {
    return problema;
  }
}

export async function interpretWithPlumber(problema, signals, tipo = 'general') {
  try {
    const resumen = `Señales: ${signals.length} | Riesgos: ${signals.filter(s => s.classification === "Riesgo").length} | Oportunidades: ${signals.filter(s => s.classification === "Oportunidad").length}`;
    const res = await fetch(`${API_BASE}/llm`, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ problema, resumen, tipo })
    });
    const data = await res.json();
    return data.texto || null;
  } catch (e) {
    console.error('Plumber /llm error:', e);
    return null;
    const texto = data.texto;
    return Array.isArray(texto) ? texto[0] : texto || null;
  }
}

function sanitizeText(text) {
  return text
    .replace(/[\u0080-\u009F]/g, '')
    .normalize('NFC');
}

export async function generatePlan(problema, n_signals, n_scenarios, clusters, perfil = {}, signals = []) {
  try {
    const topSignals = signals
      .sort((a, b) => (+b.impact_probability || 0) - (+a.impact_probability || 0))
      .slice(0, 10)
      .map(s => `- ${s.Title} (${s.pestel_category}, ${Math.round((+s.impact_probability || 0) * 100)}% impacto)`)
      .join('\n');

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 90000);
    const res = await fetch(`${API_BASE}/plan`, {
      method: 'POST',
      headers: HEADERS,
      signal: controller.signal,
      body: JSON.stringify({
        problema,
        n_signals,
        n_scenarios,
        clusters,
        top_signals: topSignals,
        sector: perfil.sector || "",
        facturacion: perfil.facturacion || "",
        plazo: perfil.plazo || "",
        obstaculo: perfil.obstaculo || "",
        sostenibilidad_escenarios: perfil.sostenibilidad_escenarios || "",
        indicadores_ambientales: perfil.indicadores_ambientales || "",
        incremento_facturacion: perfil.incremento_facturacion || "0",
        objetivo: perfil.objetivo || "",
        mercados: perfil.mercados || "",
        departamento: perfil.departamento || "",
      })
    });
    clearTimeout(timeoutId);
    if (!res.ok) {
      console.error("Plan API error:", res.status, await res.text());
      return null;
    }
    const data = await res.json();
    console.log("Plan data desde API:", data);
    return data;
  } catch (e) {
    console.error("generatePlan error:", e);
    return null;
  }
}

export async function generateFoda(problema, signals) {
  try {
    const res = await fetch(`${API_BASE}/foda`, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ problema, signals: signals.slice(0, 30) })
    });
    const data = await res.json();
    return data.foda || null;
  } catch (e) {
    console.error('Plumber /foda error:', e);
    return null;
  }
}

export async function fetchFinancial() {
  try {
    const res = await fetch(`${API_BASE}/financial`, {
      headers: HEADERS
    });
    return await res.json();
  } catch (e) {
    console.error('Plumber /financial error:', e);
    return [];
  }
}

export async function generateImpacto(problema, escenarios, sector = "", facturacion = "") {
  try {
    const res = await fetch(`${API_BASE}/impacto`, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ problema, escenarios, sector, facturacion })
    });
    const data = await res.json();
    return data.impacto || null;
  } catch (e) {
    console.error('Impacto error:', e);
    return null;
  }
}

export async function generateMicmac(signals, numEvents = 15) {
  try {
    const res = await fetch(`${API_BASE}/micmac`, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({ signals: signals.slice(0, 50), num_events: numEvents })
    });
    const data = await res.json();
    console.log("MICMAC raw response:", JSON.stringify(data));
    if (!data.micmac) return null;

    const variables = (data.micmac.variables || []).map(v => ({
      event_id: Array.isArray(v.event_id) ? v.event_id[0] : v.event_id,
      signal_id: Array.isArray(v.signal_id) ? v.signal_id[0] : v.signal_id,
      titulo: (() => {
        const raw = Array.isArray(v.titulo) ? v.titulo[0] : v.titulo;
        return raw ? raw.replace(/<[0-9a-f]{2}>/gi, '').trim() : 'Sin título';
      })(),
      pestel: Array.isArray(v.pestel) ? v.pestel[0] : v.pestel,
      motricidad: Array.isArray(v.motricidad) ? v.motricidad[0] : v.motricidad,
      dependencia: Array.isArray(v.dependencia) ? v.dependencia[0] : v.dependencia,
      cuadrante: Array.isArray(v.cuadrante) ? v.cuadrante[0] : v.cuadrante,
    }));

    console.log("Variables normalizadas:", variables.slice(0, 2));
    console.log("Cuadrantes:", variables.map(v => v.cuadrante));
    console.log("Event IDs:", variables.map(v => v.event_id));
    console.log("Signal IDs:", variables.map(v => v.signal_id));
    console.log("Narrativa:", data.micmac.narrativa);

    const narrativa = Array.isArray(data.micmac.narrativa)
      ? data.micmac.narrativa[0]
      : data.micmac.narrativa;

    return { variables, narrativa };
  } catch (e) {
    console.error('MICMAC error:', e);
    return null;
  }
}

export function generateHorizontes(problema, h1Signals, h2Signals, h3Signals) {
  const fmt = (sigs) => sigs.slice(0, 3).map(s => s.Title);

  const opps = (sigs) => sigs
    .filter(s => s.classification === "Oportunidad")
    .slice(0, 3).map(s => s.Title);

  const risks = (sigs) => sigs
    .filter(s => s.classification === "Riesgo")
    .slice(0, 3).map(s => s.Title);

  return {
    h1: {
      titulo: "Gestión del presente",
      descripcion: `${h1Signals.length} señales de corto plazo identificadas. Requieren acción inmediata.`,
      oportunidades: opps(h1Signals),
      riesgos: risks(h1Signals),
      accion: "Monitorear y responder en los próximos 12 meses."
    },
    h2: {
      titulo: "Construcción del futuro cercano",
      descripcion: `${h2Signals.length} señales de mediano plazo. Ventana de preparación estratégica.`,
      oportunidades: opps(h2Signals),
      riesgos: risks(h2Signals),
      accion: "Desarrollar capacidades y alianzas en los próximos 3-5 años."
    },
    h3: {
      titulo: "Creación de opciones de futuro",
      descripcion: `${h3Signals.length} señales de largo plazo. Señales débiles de transformación estructural.`,
      oportunidades: opps(h3Signals),
      riesgos: risks(h3Signals),
      accion: "Explorar e invertir en innovación para el horizonte de 5-10 años."
    }
  };
}

export async function fetchRegulaciones(sector = "") {
  try {
    const res = await fetch(
      `${API_BASE}/regulaciones?sector=${encodeURIComponent(sector)}`,
      { headers: HEADERS }
    );
    return await res.json();
  } catch (e) {
    console.error('Regulaciones error:', e);
    return { total: 0, normativa: [], datos_gov: [] };
  }
}

export async function fetchSostenibilidad(departamento, sector, problema, escenarios = [], incrementoFacturacion = "0") {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 180000);
    const res = await fetch(`${API_BASE}/sostenibilidad`, {
      method: 'POST',
      headers: HEADERS,
      signal: controller.signal,
      body: JSON.stringify({ departamento, sector, problema, escenarios, incremento_facturacion: incrementoFacturacion })
    });
    clearTimeout(timeoutId);
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (e) {
    console.error('Sostenibilidad error:', e);
    return null;
  }
}